export default __webpack_public_path__ + "static/media/uploading_cloud.aeb8f30a.svg";